import type { NavigateFunction } from "react-router-dom";
import { Role } from "../../../../packages/vars/src";

export interface NavigationItem {
	label: string;
	icon: React.ElementType;
	isActive?: boolean;
	href: string;
	disabled?: boolean;
	roles?: Role[];
	activePattern?: string | string[];
}

export const isActive = (
	currentPath: string,
	item: NavigationItem,
): boolean => {
	if (!item.activePattern) {
		if (item.href === "/") {
			return currentPath === item.href;
		}
		return currentPath.startsWith(item.href);
	}

	const patterns = Array.isArray(item.activePattern)
		? item.activePattern
		: [item.activePattern];

	return patterns.some((pattern) => {
		if (!pattern.includes(":")) {
			return currentPath.startsWith(pattern);
		}

		const patternParts = pattern.split("/").filter(Boolean);
		const pathParts = currentPath.split("/").filter(Boolean);

		if (pathParts.length !== patternParts.length) {
			return false;
		}

		return patternParts.every((part, index) => {
			if (part.startsWith(":")) {
				return true;
			}
			return part === pathParts[index];
		});
	});
};

/**
 * Navigate back with fallback if no history
 *
 * @example
 * navigateBack({ navigate, fallbackUrl: '/projects' });
 * navigateBack({ navigate, fallbackUrl: '/projects', replace: true });
 */
export const navigateBack = ({
	navigate,
	fallbackUrl = "/",
	replace = false,
}: {
	navigate: NavigateFunction;
	fallbackUrl?: string;
	replace?: boolean;
}) => {
	if (replace) {
		navigate(fallbackUrl, { replace: true });
	} else if (window.history.length > 1) {
		navigate(-1);
	} else {
		navigate(fallbackUrl);
	}
};
